import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { Logger, CredentialsService } from '../utils';

const log = new Logger('AuthenticationGuard');

export const authenticationGuard = () => {
  const router = inject(Router);
  const credentialsService = inject(CredentialsService);

  if (credentialsService.isAuthenticated()) return true;

  log.debug('Not authenticated, redirecting and adding redirect url...');
  router.navigateByUrl('/login', { replaceUrl: true });
  return false;
};
